"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NavigationListItem = _interopRequireDefault(require("../../Navigation/NavigationList/NavigationListItem"));

var _Layout = require("../../Layout");

var _FooterNavigation = require("./FooterNavigation.style");

var _MarkdownRenderer = _interopRequireDefault(require("../../MarkdownRenderer"));

var FooterNavigation = function FooterNavigation(_ref) {
  var columns = _ref.columns,
      isLargeNav = _ref.isLargeNav,
      rest = _objectWithoutProperties(_ref, ["columns", "isLargeNav"]);

  var NavContainer = isLargeNav ? _Layout.Container : 'div';
  return /*#__PURE__*/_react.default.createElement(NavContainer, null, /*#__PURE__*/_react.default.createElement(_Layout.Grid, {
    flexDirection: isLargeNav ? 'row' : 'column-reverse'
  }, columns.map(function (column, key) {
    var component = column.component,
        label = column.label,
        type = column.type;
    return /*#__PURE__*/_react.default.createElement(_Layout.Column // eslint-disable-next-line react/no-array-index-key
    , {
      key: "".concat(label, "_").concat(key),
      width: [12, null, null, 6, 3]
    }, type && type === 'nav' && /*#__PURE__*/_react.default.createElement(_NavigationListItem.default, Object.assign({
      link: component
    }, rest, {
      isLargeNav: isLargeNav
    })), type && type === 'html' && /*#__PURE__*/_react.default.createElement(_FooterNavigation.FooterNavItem, null, component.label && /*#__PURE__*/_react.default.createElement(_FooterNavigation.FooterContainer, null, /*#__PURE__*/_react.default.createElement(_FooterNavigation.FooterTitle, {
      as: "h4"
    }, component.label)), /*#__PURE__*/_react.default.createElement(_FooterNavigation.FooterContactSection, null, /*#__PURE__*/_react.default.createElement(_FooterNavigation.FooterHtmlContainer, null, /*#__PURE__*/_react.default.createElement(_MarkdownRenderer.default, {
      html: component.html
    })))));
  })));
};

FooterNavigation.propTypes = {
  columns: _propTypes.default.arrayOf(Object).isRequired,
  isLargeNav: _propTypes.default.bool
};
FooterNavigation.defaultProps = {
  isLargeNav: false
};
var _default = FooterNavigation;
exports.default = _default;